import { CheckCircle2, FileLock2, ListChecks, Sparkles } from "lucide-react";
import { Card } from "../ui/Card";
import { Section } from "../ui/Section";

const steps = [
  {
    icon: CheckCircle2,
    title: "Ξεκινάς το IQ Test",
    text: "Επιλέγεις ηλικιακό εύρος, βλέπεις τις οδηγίες και ξεκινάς το 30-question IQ-style challenge."
  },
  {
    icon: ListChecks,
    title: "Απαντάς σε 30 ερωτήσεις",
    text: "Το test περιλαμβάνει μοτίβα, χωρική αντίληψη, συμβολική λογική, αριθμητικές σχέσεις και ασκήσεις προσοχής. Ο χρόνος κάθε απάντησης καταγράφεται για την αναφορά επίδοσης."
  },
  {
    icon: FileLock2,
    title: "Βλέπεις κλειδωμένη προεπισκόπηση",
    text: "Μετά την ολοκλήρωση εμφανίζεται μια σύντομη προεπισκόπηση του αποτελέσματος και των στοιχείων που περιλαμβάνει το Premium Report."
  },
  {
    icon: Sparkles,
    title: "Ξεκλειδώνεις το Premium Report",
    text: "Το report παρουσιάζει IQ Score, εύρος εκτίμησης, προφίλ επίδοσης, ανάλυση χρόνου, δείκτη συνέπειας και προτάσεις προόδου."
  }
];

export function HowItWorksSection() {
  return (
    <Section id="how-it-works" className="scroll-mt-24 py-12 sm:py-16">
      <div className="max-w-2xl">
        <h2 className="text-3xl font-bold text-white sm:text-4xl">Πώς λειτουργεί</h2>
        <p className="mt-3 text-slate-300">Η εμπειρία είναι καθαρή, γρήγορη και σχεδιασμένη ώστε να ολοκληρώνεται εύκολα από κινητό ή desktop.</p>
      </div>
      <div className="mt-7 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <Card key={step.title} className="relative overflow-hidden">
              <span className="absolute right-4 top-4 text-5xl font-bold text-white/[0.035]">0{index + 1}</span>
              <Icon className="text-cyan-200" size={26} />
              <h3 className="mt-5 text-lg font-semibold text-white">{step.title}</h3>
              <p className="mt-3 text-sm leading-6 text-slate-300">{step.text}</p>
            </Card>
          );
        })}
      </div>
    </Section>
  );
}
